import { makeAutoObservable } from "mobx";
import { DELETE, GET, PATCH, POST, GET_USER } from "../apis/apis";
import { message } from "antd";

class RequestsStore {
  requestListings = [];
  requestListing = null;
  currentRequestId = null;
  requests = [];
  loading = false;
  searchTerm = "";

  constructor() {
    makeAutoObservable(this);
  }

  setRequestListings(value) {
    this.requestListings = value;
  }

  setRequestListing(value) {
    this.requestListing = value;
  }

  setCurrentRequestId(value) {
    this.currentRequestId = value;
  }

  setRequests(value) {
    this.requests = value;
  }

  setLoading(value) {
    this.loading = value;
  }

  setSearchTerm(value) {
    this.searchTerm = value;
  }

  GetRequestListings = async () => {
    try {
      this.setLoading(true);
      const data = await GET("/request-listing/");
      this.setRequestListings(data);
    } catch (error) {
      console.error(error);
    } finally {
      this.setLoading(false);
    }
  };

  GetRequestListingById = async (id) => {
    try {
      this.setLoading(true);
      const data = await GET_USER(`/request-listing/${id}`);
      this.setRequestListing(data);
      this.setCurrentRequestId(data.id);
    } catch (error) {
      console.error(error);
    } finally {
      this.setLoading(false);
    }
  };

  GetRequestListingApplicantById = async (id) => {
    try {
      this.setLoading(true);
      const data = await GET(`/request-listing/applicant/${id}`);
      this.setRequestListing(data);
      this.setCurrentRequestId(data.id);
    } catch (error) {
      console.error(error);
    } finally {
      this.setLoading(false);
    }
  };

  GetRequestsSearchResults = async () => {
    try {
      this.setLoading(true);
      const data = await GET(`/request-listing/?search=${this.searchTerm}`);
      this.setRequestListings(data);
    } catch (error) {
      console.error(error);
    } finally {
      this.setLoading(false);
    }
  };

  GetRequestsFilteredResults = async (type) => {
    try {
      this.setLoading(true);
      const data = await GET(`/request-listing/type/${type}`);
      this.setRequestListings(data);
    } catch (error) {
      console.error(error);
    } finally {
      this.setLoading(false);
    }
  };

  PostRequestListing = async (data) => {
    try {
      this.setLoading(true);
      await POST(`/request-listing/create/`, data);
      await this.GetRequestListings();
      message.success("Request created successfully");
    } catch (error) {
      console.error(error);
      message.error("Error creating the request");
    } finally {
      this.setLoading(false);
    }
  };

  PatchRequestListing = async (id, data) => {
    try {
      await PATCH(`/request-listing/${id}`, data);
      await this.GetRequestListingById(id);
      message.success("Request updated successfully");
    } catch (error) {
      console.error(error);
      message.error("Error updating the request");
    }
  };

  PatchRequest = async (id, status) => {
    try {
      await PATCH(`/request/${id}`, status);
      await this.GetRequestListingById(id);
      message.success("Request status updated successfully");
    } catch (error) {
      console.error(error);
      message.error("Error updating the request status");
    }
  };

  DeleteRequestListingById = async (id) => {
    try {
      this.setLoading(true);
      await DELETE(`/request-listing/${id}`);
      await this.GetRequestListings();
    } catch (error) {
      console.error(error);
    } finally {
      this.setLoading(false);
    }
  };

  PostRequest = async (data) => {
    try {
      this.setLoading(true);
      await POST("/request", data);
      message.success("Application successful");
    } catch (error) {
      console.error(error);
      message.error("Application error");
    } finally {
      this.setLoading(false);
    }
  };
}

export { RequestsStore };
